import { Button as ButtonComponent, Spacing, Text as TextComponent } from '@billy/design-system'
import styled from '@emotion/styled'

export const EmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-top: -${Spacing.S24};
  text-align: center;
`

export const Button = styled(ButtonComponent)`
  margin: 0 auto;
`

export const Text = styled(TextComponent)`
  margin: 0 auto;
`
